<template>
	<div id="idFrmPan" ref="idFrmPan" style="display:flex; flex-direction:column; border:0px solid blue; height:100%;">
		<popwin style="width:100%; height:100%;" :ctrl="ctrlWin"></popwin>
		<popmenu style="width:100%; height:100%;" :ctrl="ctrlMenu"></popmenu>

		<div style="flex: 0 0 auto; width:100%; height:50px; border:0px solid red;">
			<div class="SiftPanel">
				<div class="NButton DIVNoSelect" style="width:70px; margin-top:-1px; margin-left:10px;" @click="onSourceAddClick">{{getLangText('新增')}}</div>

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('素材名称')}}</div>
				<input type="text" style="width:200px;" v-model="findSourceName">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('素材类型')}}</div>
				<cselect style="position:relative; height:30px; min-width:120px; z-index:999;" :defv="findImgType" v-model="findImgType" :ctrl="ctrlImgType" :csData="dataImgType"></cselect>
				<cselect style="position:relative; height:30px; min-width:120px; z-index:999;" :defv="findPasterType" v-model="findPasterType" :ctrl="ctrlPasterType" :csData="dataPasterType"></cselect>

				<!--div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('权益')}}</div>
				<cselect style="position:relative; height:30px; min-width:80px; z-index:999;" :defv="findEquityLevel" v-model="findEquityLevel" :ctrl="ctrlEquityLevel" :csData="dataEquityLevel"></cselect-->

				<check style="height:30px; margin-right:10px; margin-left:20px;" :size="18" :grpName="'GrpRange'" :val="2" :capt="getLangText('私有')" :key="KeyPrivate" :checked="chkPrivate"></check>
				<check style="height:30px; margin-right:20px;"                   :size="18" :grpName="'GrpRange'" :val="1" :capt="getLangText('共享')" :key="KeyShare"   :checked="chkShare"></check>

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onSourceListClick"></div>
			</div>
		</div>
		<div style="flex: 1 0 auto; width:100%; height:100%; border:0px solid blue;" id="idListPan" ref="idListPan">
			<div style="flex: 1 0 auto; width:100%; height:100%; border:0px solid blue; display:flex; flex-direction:row; flex-wrap:wrap; overflow-y:auto;" :key="KeyList">
				<div style="flex:0 0 auto; width:254px; height:336px; border:1px solid #bbbbbb; margin-left:70px; margin-top:40px; position:relative; z-index:900;" v-for="(curItem, index) in imgData" :index="index">
					<div style="z-index:990; position:absolute; width:57px; height:57px; background:url(../static/images/publish3.png);" v-if="curItem.siCustId>0"></div>
					<div style="z-index:990; position:absolute; width:57px; height:57px; background:url(../static/images/publish2.png);" v-if="curItem.siCustId==0"></div>
					<div style="z-index:991; position:absolute; transform: rotate(-45deg) scale(0.7); left:-14px; top:10px; width:70px; height:20px; line-height:20px; border:0px solid red; color:#ffffff; text-align:center; font-size:14px;" class="DIVNoSelect">{{curItem.publicText}}</div>
					<!--div style="z-index:992; position:absolute; width:28px; height:28px; left:220px; background:url(../static/images/vip_1.png); background-size:100% 100%;" v-if="curItem.siEquityLevel==130"></div>
					<div style="z-index:992; position:absolute; width:28px; height:28px; left:220px; background:url(../static/images/vip_2.png); background-size:100% 100%;" v-if="curItem.siEquityLevel==131"></div>
					<div style="z-index:992; position:absolute; width:28px; height:28px; left:220px; background:url(../static/images/vip_3.png); background-size:100% 100%;" v-if="curItem.siEquityLevel==132"></div-->
					<ImgThumOP :item="curItem" :key="curItem.siId" :ty="'100'" style="z-index:992; position:absolute; width:28px; height:28px; left:220px;"></ImgThumOP>

					<div style="float:left; width:253px; height:48px; line-height:30px; text-align:center; border-bottom:1px solid #bbbbbb; font-size:14px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{curItem.siNameEng}}</div>
					<table style="float:left; margin-top:-20px; width:100%; font-size:12px; color:#aaaaaa;">
						<tr><td style="text-indent:26px;">{{"size: "+curItem.width+" * "+curItem.height}}</td>
							<td style="text-indent:6px;">{{"times: "+curItem.siUsedTimes}}</td></tr>
					</table>

					<div style="float:left; width:253px; height:253px; background:#bbbbbb; border:0px solid #bbbbbb;">
						<ImgThum :key="freshKey2+index" :item="curItem" :thW=244 :thH=244 style="float:left; border:0px solid red; width:100%; height:100%;"></ImgThum>
					</div>

					<div style="float:left; width:253px; height:36px; border-top:1px solid #bbbbbb; padding-top:3px;">
						<ImgThumOP :item="curItem" :ty="'1'" :dty="'src'" :clk="onPreviewClk"></ImgThumOP>
						<!--ImgThumOP :item="curItem" :ty="'3'" :dty="'src'" :clk="onEquitySetClick" style="float:left; margin-left:6px;" ></ImgThumOP-->
						<ImgThumOP :item="curItem" :ty="'4'" :dty="'src'" :clk="onShareSetClick"  style="float:left; margin-left:6px;" ></ImgThumOP>
						<ImgThumOP :item="curItem" :ty="'2'" :dty="'src'" :clk="onSourceDelClick" style="float:right; margin-right:6px;" ></ImgThumOP>
					</div>
				</div>
			</div>
		</div>
		<div style="flex: 0 0 auto; width:100%; height:30px; border:0px solid red;">
			<cpage :key="keyFind" :ctrl="ctrlPage" style="margin-left:0px;"></cpage>
		</div>
	</div>
</template>

<script>

import ImgThum    from './ImgThum'
import ImgThumOP  from './ImgThumOP'
import cselect    from '../cf/cselect'
import check      from '../cf/cck'
import popwin     from '../cf/popwin'
import popmenu    from '../cf/popmenu'
import cpage      from '../cf/cpage'

export default {
	name: 'SourceList',
	components:{
		ImgThumOP, ImgThum, cselect, check, popwin, popmenu, cpage
	},
	data () {
		return {
			frmW: 0,
			frmH: 0,
			freshKey2:  2000,
			keyFind:    3000,
			KeyList:    4000,
			KeyPrivate: 5000,
			KeyShare:   6000,
			ctrlPage: {
				havNote: true,                  //是否显示提示信息
				havGo: true,                    //是否显示页号输入及按钮
				total: 0,                       //总记录数
				pageSize: 10,                   //每页记录条数
				pageIdx: 0,                     //当前页码
				cont:[LangText('共'), LangText('条记录,'), LangText('页'), LangText('条/页'), LangText('页码'),'Go'],
				qryFunc: this.onSourceListClick,      //查询回调函数
			},
			imgData:[],                           // 素材列表

			ctrlWin:{                               // 弹出窗口控制属性
				w2: 500,
				h2: 440,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				vuepath: "/FrameBody/SourceList/SourceNew",
				rcallFunc: this.onSourceListClick,                 // 指定关闭弹出窗后需要执行的回调方法
			},
			ctrlMenu:{},                             // 弹出菜单控制属性

			findSourceName: "",                   // 素材名称
			findImgType: "",                      // 素材类型
			ctrlImgType: {
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 4
			},
			findPasterType: "160",                   // 贴纸类型
			ctrlPasterType: {
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},
			findEquityLevel: "132",                   // 权益等级
			/*ctrlEquityLevel:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},*/
			chkPrivate: false,
			chkShare: false,
		}
	},
	mounted: function(){
		if( !parseInt(this.login.userId) ) return;

		this.frmW=this.$refs["idFrmPan"].clientWidth;
		this.frmH=this.$refs["idFrmPan"].clientHeight;
		this.$refs["idListPan"].style["height"] = (this.frmH-80)+"px";
		this.$refs["idListPan"].style["width"]  = (this.frmW)+"px";

		this.findImgType = this.myRouteParam.ty;
		this.ctrlImgType.self.setDisabled( true );
		if( this.findImgType!=150 )
		{
			this.findPasterType = "160";
			this.ctrlPasterType.self.setDisabled( true );
		}
		else
		{
			this.findPasterType = "";
			this.ctrlPasterType.self.setDisabled( false );
		}

		if( 0 <= (this.myRouteParam.findCustRange+"").indexOf("2") ) this.chkPrivate = true;
		if( 0 <= (this.myRouteParam.findCustRange+"").indexOf("1") ) this.chkShare = true;
		this.KeyPrivate++;
		this.KeyShare++;

		this.doTrade( "POST", ServAddr+"/api/cust/getCustInfo", this.getCustInfoOK, true, {custId: this.login.custId }, null );
	},
	watch:{

	},
	computed:{

	},
	methods:{
		onResize: function(){
			this.frmW=this.$refs["idFrmPan"].clientWidth;
			this.frmH=this.$refs["idFrmPan"].clientHeight;

			if( this.frmH > 0 ) this.$refs["idListPan"].style["height"] = (this.frmH-80)+"px";
			this.$refs["idListPan"].style["width"]  = (this.frmW)+"px";

			this.childResize( this );
		},
		onSourceAddClick: function(){
			if( this.findPasterType=="" )
			{
				this.appRoot.app.showDlgCfm( this.DialogType.Tip, LangText("提示"), LangText("请选择贴纸类型"), "", null );
				return;
			}

			this.ctrlWin.captCont = LangText("新增素材");
			this.ctrlWin.info={ imgType: this.findImgType, pasterType: this.findPasterType };
			this.ctrlWin.self.onShow();
		},
		getCustInfoOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			if( data.body.custSourceFlag==0 ) this.chkShare = false;
			this.KeyShare++;

			setTimeout( this.onSourceListClick, 50 );
		},
		onSourceListClick: function(){
			let body={ pageSize:this.ctrlPage.pageSize, curPage:this.ctrlPage.pageIdx-1, siCustId:this.login.custId, siNameEng:this.findSourceName,
						siImgType:parseInt(this.findImgType) };
			body.siPasterType = parseInt(this.findPasterType);
			body.siEquityLevel = parseInt(this.findEquityLevel);

			let v=this.getCheckValuesByName( "GrpRange");
			if( v=="1,2" || v=="2,1" )
				 body.custRange = 3;
			else body.custRange = parseInt(v);

			this.doTrade( "POST", ServAddr+"/api/source/sourceList", this.onSourceListOK, true, body, null );
		},
		onSourceListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.imgData = [];
			for(let i=0; i<data.body.sourceList.length; i++ )
			{
				let item=data.body.sourceList[i];

				let img={};
				img.siCustId      = item.siCustId;
				img.siNameEng     = item.siNameEng;
				img.siId          = item.siId;
				img.width         = item.siSize.split(",")[0];
				img.height        = item.siSize.split(",")[1];
				img.siUsedTimes   = item.siUsedTimes;
				img.siEquityLevel = item.siEquityLevel;
				img.siEquityText  = this.getEquityText(item.siEquityLevel);
				img.siImgType     = item.siImgType;
				img.siPasterType  = item.siPasterType;
				img.siVerno       = item.siVerno;
				img.path          = item.siImgPath;
				img.areas         = [];
				if( img.siCustId == 0 )
					 img.publicText = LangText("共享");
				else img.publicText = LangText("私有");

				this.imgData.push( img );
			}
			this.freshKey2++;
			this.ctrlPage.total = data.body.allCnt;
			this.keyFind++;
			this.KeyList++;
		},
		onPreviewClk: function( item ){
			window.open( item.path, "_blank");
		},
		onSourceDelClick: function( event, item ){
			this.appRoot.app.showDlgCfm( this.DialogType.War, LangText("警告"), LangText("确定要删除吗?"), "", {okFunc:this.doSourceDel, okParam:item} );
		},
		doSourceDel: function( item ){
			this.doTrade( "DELETE", ServAddr+"/api/source/sourceDel/"+item.siId, this.onSourceListClick, true, null, null );
		},
		onEquitySetClick: function( e, item ){
			this.ctrlMenu.captCont = LangText("权益等级");
			this.ctrlMenu.info={ imgType: this.findImgType, pasterType: this.findPasterType };
			let menus=[
					{ name:LangText("NOR"),  rcall:this.setEquityLevel, recId:item.siId, newV:130 },
					{ name:LangText("VIP"),  rcall:this.setEquityLevel, recId:item.siId, newV:131 },
					{ name:LangText("SVIP"), rcall:this.setEquityLevel, recId:item.siId, newV:132 },
				];
			this.ctrlMenu.self.onShow( e, menus );
		},
		setEquityLevel: function( recId, newV ){
			let body={ siEquityLevel: newV };
			this.doTrade( "PUT", ServAddr+"/api/source/equitySet/"+recId, this.onSourceListClick, true, body, null );
		},
		onShareSetClick: function( e, item ){
			this.appRoot.app.showDlgCfm( this.DialogType.War, LangText("提示"), LangText("确定要共享吗?"), "", {okFunc:this.doSourceShare, okParam:item} );
		},
		doSourceShare: function( param ){
			this.doTrade( "PUT", ServAddr+"/api/source/shareSet/"+param.siId, this.onSourceListClick, true, null, null );
		},
	}
}

</script>

<style scoped>

.OP1Icon{ float:left; width:26px; height:26px; border:1px solid #47c2d0; cursor:pointer; }
.OP1Icon:hover{ opacity:0.7; }

.OP2Icon{ float:left; width:26px; height:26px; border:1px solid #c4c4c4; }

</style>



// WEBPACK FOOTER //
// SourceList.vue?162e68ea